import { AestraPrimaryCareTable } from "../../../data-model/aestraPrimaryCareTable";
import { FilterSection } from "../../../data-model/filterValues";
import { allAuthTypeOptions } from "./filterOptions/authTypeFilterOptions";
import { allCaseStatusOptions } from "./filterOptions/caseStatusFilterOptions";
import { allKeySourceOptions } from "./filterOptions/keySourceFilterOptions";
import { allPocOptions } from "./filterOptions/pocFilterOptions";
import { allResponseStatusOptions } from "./filterOptions/responseStatusFilterOptions";
import { allRouteViaOptions } from "./filterOptions/routeViaFilterOptions";
import { allSecondStpStatusOptions } from "./filterOptions/secondStpStatusFilterOptions";

export enum PrimaryCareFilterKeys {
  SECOND_STP_STATUS = "second_stp_status",
  RESPONSE_STATUS = "response_status",
  CASE_STATUS = "case_status",
  POC = "poc",
  DATE_OF_SERVICE = "date_of_service",
  ROUTE_VIA = "route_via",
  AUTH_TYPE = "auth_type",
  KEY_SOURCE = "key_source",
}

export const createFilterForSecondStpStatus = (
  _data: AestraPrimaryCareTable[],
): FilterSection => {
  return {
    id: PrimaryCareFilterKeys.SECOND_STP_STATUS,
    label: "Status",
    options: allSecondStpStatusOptions,
    type: "string",
  };
};

export const createFilterForResponseStatus = (
  _data: AestraPrimaryCareTable[],
): FilterSection => {
  return {
    id: PrimaryCareFilterKeys.RESPONSE_STATUS,
    label: "Response Status",
    options: allResponseStatusOptions,
    type: "string",
  };
};

export const createFilterForCaseStatus = (
  _data: AestraPrimaryCareTable[],
): FilterSection => {
  return {
    id: PrimaryCareFilterKeys.CASE_STATUS,
    label: "Case Status",
    options: allCaseStatusOptions,
    type: "string",
  };
};

export const createFilterForPoc = (
  _data: AestraPrimaryCareTable[],
): FilterSection => {
  return {
    id: PrimaryCareFilterKeys.POC,
    label: "Assigned To",
    options: allPocOptions,
    type: "string",
  };
};

export const createFilterForRouteVia = (
  _data: AestraPrimaryCareTable[],
): FilterSection => {
  return {
    id: PrimaryCareFilterKeys.ROUTE_VIA,
    label: "Route Via",
    options: allRouteViaOptions,
    type: "string",
  };
};

export const createFilterForAuthType = (
  _data: AestraPrimaryCareTable[],
): FilterSection => {
  return {
    id: PrimaryCareFilterKeys.AUTH_TYPE,
    label: "Auth Type",
    options: allAuthTypeOptions,
    type: "string",
  };
};

export const createFilterForKeySource = (
  _data: AestraPrimaryCareTable[],
): FilterSection => {
  return {
    id: PrimaryCareFilterKeys.KEY_SOURCE,
    label: "Key Source",
    options: allKeySourceOptions,
    type: "string",
  };
};

export const createFilterForDateOfService = (): FilterSection => {
  return {
    id: PrimaryCareFilterKeys.DATE_OF_SERVICE,
    label: "Date of Service",
    options: [],
    type: "date",
  };
};

export const createAllFilterSections = (
  data: AestraPrimaryCareTable[],
): FilterSection[] => {
  if (!data || data.length === 0) {
    return [];
  }

  return [
    createFilterForDateOfService(),
    createFilterForSecondStpStatus(data),
    createFilterForResponseStatus(data),
    createFilterForAuthType(data),
    createFilterForKeySource(data),
    createFilterForCaseStatus(data),
    createFilterForRouteVia(data),
    createFilterForPoc(data),
  ];
};
